import {Injectable, Type} from '@angular/core';
import {Router} from '@angular/router';
import {PageWiseIntroText} from 'src/app/security/menu-entity';
import {EnPageNameEnum, EnUserTypes} from 'src/app/security/page-name.enum';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {SecurityQuestionAnswer} from 'src/app/security/QueryStringParam';
import {MyProfileModel} from '../model/UserProfile';
import {Config} from '../model/interfaces';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

declare var myExtObject: any;


export enum GridConfigItem {
  INVESTOR = 'INVESTOR',
  INVESTOR_DISTRIBUTION = 'INVESTOR_DISTRIBUTION',
  INVESTOR_TRANSACTION = 'INVESTOR_TRANSACTION',
  ACTIVE_INVESTMENT_HOME_PAGE = 'ACTIVE_INVESTMENT_HOME_PAGE',
  ACTIVE_FUND_HOME_PAGE = 'ACTIVE_FUND_HOME_PAGE',
  INACTIVE_INVESTMENT_HOME_PAGE = 'INACTIVE_INVESTMENT_HOME_PAGE',
}

export const EmailRegex = new RegExp('^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$');


@Injectable()
export class AuthServiceCustom {

  configurationSet$ = new Subject<void>();
  newTokenSet = false;

  get configReady() {
    return this.initialized;
  }

  set configReady(value: boolean) {
    this.initialized = value;
  }

  constructor(private router: Router, private httpClient: HttpClient) {
    this.baseUrl = myExtObject.APIUrl;
  }

  get originalUser(): any {
    return (this.TempUsers && this.TempUsers[0]) || this;
  }

  get clientCode() {
    if (!this._clientCode) {
      this._clientCode = JSON.parse(localStorage.getItem(environment.star_clientid+'clientCode'));
    }
    return this._clientCode;
  }

  set clientCode(arg) {
    this._clientCode = arg;
    localStorage.setItem(environment.star_clientid+'clientCode', JSON.stringify(this._clientCode));
    localStorage.setItem('lastClientCode', JSON.stringify(this._clientCode));
  }

  get lastClientCode() {
    return JSON.parse(localStorage.getItem('lastClientCode'));
  }

  get envStarClientId() {
    return environment.star_clientid;
  }

  get StarClientId(): string {
    return sessionStorage.getItem('StarClientId');
  }

  set StarClientId(StarClientId) {
    if (!StarClientId) {
      sessionStorage.removeItem('StarClientId');
    } else {
      sessionStorage.setItem('StarClientId', StarClientId);
    }
  }


  get WpProxyFlag() {
    if (!this._wpProxyFlag) {
      this._wpProxyFlag = JSON.parse(localStorage.getItem(environment.star_clientid+'WpProxyFlag'));
    }
    return this._wpProxyFlag;
  }

  set WpProxyFlag(arg) {
    this._wpProxyFlag = arg;
    localStorage.setItem(environment.star_clientid+'WpProxyFlag', JSON.stringify(this.WpProxyFlag));
  }

  get clientAddress() {
    if (!this._clientAddress) {
      this._clientAddress = JSON.parse(localStorage.getItem(environment.star_clientid+'clientAddress'));
    }
    return this._clientAddress;
  }

  set clientAddress(arg) {
    this._clientAddress = arg;
    if (arg) {
      localStorage.setItem(environment.star_clientid+'clientAddress', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'clientAddress');
    }
  }

  get wpContactPhone() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'wpContactPhone'));
  }

  set wpContactPhone(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpContactPhone', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpContactPhone');
    }
  }

  get wpContactEmail() {
    const json = localStorage.getItem(environment.star_clientid+'wpContactEmail');
    return json && JSON.parse(json);
  }

  set wpContactEmail(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpContactEmail', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpContactEmail');
    }
  }

  get wpContactFax() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'wpContactFax'));
  }

  set wpContactFax(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpContactFax', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpContactFax');
    }
  }

  get loginMessage() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'loginMessage'));
  }

  set loginMessage(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'loginMessage', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'loginMessage');
    }
  }

  get transactionCodes() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'transactionCodes'));
  }

  set transactionCodes(arg) {
    if (!arg) {
      localStorage.removeItem(environment.star_clientid+'transactionCodes');
    } else {
      localStorage.setItem(environment.star_clientid+'transactionCodes', JSON.stringify(arg));
    }
  }

  get distributionCodes() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'distributionCodes'));
  }

  set distributionCodes(arg) {
    if (!arg) {
      localStorage.removeItem(environment.star_clientid+'distributionCodes');
    } else {
      localStorage.setItem(environment.star_clientid+'distributionCodes', JSON.stringify(arg));
    }
  }

  set buildVersion(arg) {
    if (!arg) {
      localStorage.removeItem(environment.star_clientid+'buildVersion');
    } else {
      localStorage.setItem(environment.star_clientid+'buildVersion', JSON.stringify(arg));
    }
  }

  get buildVersion() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'buildVersion'));
  }

  set appVersion(arg) {
    if (!arg) {
      localStorage.removeItem(environment.star_clientid + 'appVersion');
    } else {
      localStorage.setItem(environment.star_clientid + 'appVersion', JSON.stringify(arg));
    }
  }

  get appVersion() {
    return JSON.parse(localStorage.getItem(environment.star_clientid + 'appVersion'));
  }

  get wpCompanyName() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'wpCompanyName'));
  }

  set wpCompanyName(arg) {
    localStorage.setItem(environment.star_clientid+'wpCompanyName', JSON.stringify(arg));
  }

  get wpCompanyShortName() {
    return JSON.parse(localStorage.getItem(environment.star_clientid+'wpCompanyShortName'));
  }

  set wpCompanyShortName(arg) {
    localStorage.setItem(environment.star_clientid+'wpCompanyShortName', JSON.stringify(arg));
  }

  get wpCompanyEmail() {
    const json = localStorage.getItem(environment.star_clientid+'wpCompanyEmail');
    return json && JSON.parse(json);
  }

  set wpCompanyEmail(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpCompanyEmail', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpCompanyEmail');
    }
  }


  get wpCompanyWebsite() {
    const json = localStorage.getItem(environment.star_clientid+'wpCompanyWebsite');
    return json && JSON.parse(json);
  }

  set wpCompanyWebsite(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpCompanyWebsite', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpCompanyWebsite');
    }
  }

  get clientHeader() {
    const json = localStorage.getItem(environment.star_clientid+'clientHeader');
    return json && JSON.parse(json);
  }

  set clientHeader(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'clientHeader', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'clientHeader');
    }
  }

  get wpCompanyPhone() {
    const json = localStorage.getItem(environment.star_clientid+'wpCompanyPhone');
    return json && JSON.parse(json);
  }

  set wpCompanyPhone(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpCompanyPhone', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpCompanyPhone');
    }
  }

  get wpIrEmail() {
    const json = localStorage.getItem(environment.star_clientid+'wpIrEmail');
    return json && JSON.parse(json);
  }

  set wpIrEmail(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpIrEmail', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpIrEmail');
    }
  }

  get wpFaqFile() {
    const json = localStorage.getItem(environment.star_clientid+'wpFaqFile');
    return json && JSON.parse(json);
  }

  set wpFaqFile(arg) {
    if (arg) {
      localStorage.setItem(environment.star_clientid+'wpFaqFile', JSON.stringify(arg));
    } else {
      localStorage.removeItem(environment.star_clientid+'wpFaqFile');
    }
  }

  set gridColumnConfigs(data: { [key: string]: Config }) {
    if (!data) {
      localStorage.removeItem(environment.star_clientid+'gridColumnConfigs');
    } else {
      this._gridColumnConfigs = data;
      localStorage.setItem(environment.star_clientid+'gridColumnConfigs', JSON.stringify(data));
    }
  }

  set Auth0ConnectionPrefix(prefix: string) {
    if (prefix) {
      localStorage.setItem(environment.star_clientid+'Auth0ConnectionPrefix', JSON.stringify(prefix));
    } else {
      localStorage.removeItem(environment.star_clientid+'Auth0ConnectionPrefix');
    }
  }

  get Auth0ConnectionPrefix() {
    const json = localStorage.getItem(environment.star_clientid+'Auth0ConnectionPrefix');
    return json && JSON.parse(json);
  }

  get Auth0Connection() {
    if (!this.Auth0ConnectionPrefix) {
      return '';
    }
    const connection = this.Auth0ConnectionPrefix + environment.star_clientid;
    return connection.toLowerCase();
  }

  get AccessToken() {
    return sessionStorage.getItem('token');
    // let token = localStorage.getItem('token');
    // if (this.tokenProfileDataReadFromSessionStorage) {
    //   token = sessionStorage.getItem('token');
    // } else if (token && this.newTokenSet == false) {
    //   this.tokenProfileDataReadFromSessionStorage = true;
    //   sessionStorage.setItem('token', token);
    // }
    // return token;
  }

  set AccessToken(token) {
    if (!token) {
      sessionStorage.removeItem('token');
    } else {
      sessionStorage.setItem('token', token);
    }
  }

  get UserType(): string {
    return sessionStorage.getItem('UserType');
  }

  set UserType(UserType) {
    if (!UserType) {
      sessionStorage.removeItem('UserType');
    } else {
      sessionStorage.setItem('UserType', UserType);
    }
  }

  get RecordNum(): string {
    return sessionStorage.getItem('RecordNum');
  }

  set RecordNum(RecordNum) {
    if (!RecordNum) {
      sessionStorage.removeItem('RecordNum');
    } else {
      sessionStorage.setItem('RecordNum', RecordNum);
    }
  }

  get WpUserNum(): string {
    return sessionStorage.getItem('WpUserNum');
  }

  set WpUserNum(WpUserNum) {
    if (!WpUserNum) {
      sessionStorage.removeItem('WpUserNum');
    } else {
      sessionStorage.setItem('WpUserNum', WpUserNum);
    }
  }

  get ForBrokerNum(): string {
    return sessionStorage.getItem('ForBrokerNum');
  }

  set ForBrokerNum(ForBrokerNum) {
    if (!ForBrokerNum) {
      sessionStorage.removeItem('ForBrokerNum');
    } else {
      sessionStorage.setItem('ForBrokerNum', ForBrokerNum);
    }
    this.clientBkrSubj.next(ForBrokerNum);
  }


  get TempUsers(): any[] {
    return JSON.parse(sessionStorage.getItem('TemporaryUser'));
  }

  set TempUsers(users: any[]) {
    sessionStorage.setItem('TemporaryUser', JSON.stringify(users));
  }

  get UserName(): string {
    return sessionStorage.getItem('UserName');
  }

  set UserName(userName) {
    sessionStorage.setItem('UserName', userName);
  }

  get UserClass(): string {
    return sessionStorage.getItem('UserClass');
  }

  set UserClass(userClass) {
    sessionStorage.setItem('UserClass', userClass);
  }

  get DifferentLoggedIn(): boolean {
    const temp = this.TempUsers;
    return temp && temp.length > 0;
  }

  get PreviousLoggedInUser(): any {
    const temp = this.TempUsers;
    return temp && temp.length && temp[temp.length - 1];
  }

set HasBeenOnceOpened(arg) {
    sessionStorage.setItem('HasBeenOnceOpened', JSON.stringify(arg));
  }

  get HasBeenOnceOpened() {
    const HasBeenOnceOpened = sessionStorage.getItem('HasBeenOnceOpened');
    return HasBeenOnceOpened == null ? false : JSON.parse(HasBeenOnceOpened);
  }

  set tokenProfileDataReadFromSessionStorage(arg) {
    sessionStorage.setItem('tokenProfileDataReadFromSessionStorage', JSON.stringify(arg));
  }

  get tokenProfileDataReadFromSessionStorage() {
    if (sessionStorage.getItem('tokenProfileDataReadFromSessionStorage') == undefined) {
      return false;
    }
    return JSON.parse(sessionStorage.getItem('tokenProfileDataReadFromSessionStorage'));
  }

  // ***************Session Storage Objects Ends******************* */

  set IntroText(arg) {

    if (arg) {
      // Insert path in this
      arg.forEach((pageData: PageWiseIntroText) => {
        let found = false;
        this.router.config.forEach((route) => {
          if (found) {
            return;
          }
          if (route.component && route.data && route.data.screenId == pageData.PageName) {
            // if(route.path.indexOf("announcement") >= 0) {
            //     pageData.Path = "/" + route.path+"announcement";
            // }
            // else{
            pageData.Path = route.path;
            // }
            if (route.path.indexOf('announcement') >= 0) {
              pageData.PathParam = {mode: 'announcement'};
            } else {
              pageData.PathParam = {};
            }
            found = true;
          }
        });
      });
      this.pageWiseIntroText = arg;
      localStorage.setItem(environment.star_clientid+'pageWiseIntroText', JSON.stringify(arg));
    }
  }

  get clientLogoUrl() {
    if (!this._clientCode) {
      return '';
    }
    return 'assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.logoName;
  }

  get clientBackgroundImageUrl() {
    if (!this.clientCode) {
      return '';
    }
    return 'assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.bgName;
  }

  get clientFooterImageUrl(): string {
    if (!this.clientCode) {
      return '';
    }
    return 'assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.footerName;
    // console.log('assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.footerName);
    // return this.httpClient
    //   .get('assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.footerName);
  }

  get clientPalette() {
    if (!this._clientCode) {
      return '';
    }
    return 'assets/Custom/' + this.clientCode.toUpperCase() + '/' + this.palette;
  }

  public logoName = 'logo.png';
  public bgName = 'bg.jpg';
  public footerName = 'footer.png';
  public palette = 'colorscheme.css';
  accessTokenRemovedSubj = new Subject<any>();
  baseUrl: string;
  routeChangedSubj = new Subject<string>();
  clientConfigLoaded = new Subject<any>();
  clientBkrSubj = new Subject<string>();

  pageWiseIntroText: Array<PageWiseIntroText> = [];
  heightOfPageContainer = 200;
  dataOfRecentlyFetchedComponentFromUrl;
  currentUserProfileEntity: MyProfileModel;
  storedFilters: any;

  private initialized: boolean;

  private redirectUrl = '/';

  public _clientCode = '';
  public _wpProxyFlag = '';

  public _clientAddress = '';

  // ***************Session Storage Objects Starts******************* */

  public _gridColumnConfigs: { [key: string]: Config };


  public passwordRegExp = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&\-=\[\](){};:\\|\*\/\.,`~])[A-Za-z\d*[@$!%*#?&\-=\[\](){};:\\|\*\/\.,`~]{8,}$/);

  getGridColumnConfigs(grid: GridConfigItem): Config {
    this._gridColumnConfigs = this._gridColumnConfigs || JSON.parse(localStorage.getItem(environment.star_clientid+'gridColumnConfigs'));
    return this._gridColumnConfigs && this._gridColumnConfigs[grid];
  }

  resetAllLocalStorageData() {
    const clientCode = this.clientCode;
    const starclientId = this.StarClientId;
    // localStorage.clear();
    sessionStorage.clear();
    this.clientCode = clientCode;
    this.StarClientId = starclientId;

  }

  getUserTypeBasedText() {
    let roleText = '';
    if (this.UserType) {
      switch (this.UserType) {
        case EnUserTypes.Investor: {
          roleText = 'Investor';
          break;
        }
        case EnUserTypes.User: {
          roleText = 'Power User';
          break;
        }
        case EnUserTypes.Rep: {
          roleText = 'Rep';
          break;
        }
        case EnUserTypes.Broker: {
          roleText = 'Broker';
          break;
        }
        case EnUserTypes.Custodian: {
          roleText = 'Custodian';
          break;
        }
        case EnUserTypes.DupMail: {
          roleText = 'Dup Mail';
          break;
        }
        case EnUserTypes.Territory: {
          roleText = 'Territory';
          break;
        }
        default: {
          roleText = '';
          break;
        }
      }

    }
    return roleText;
  }

  setAuthentication(userIdEncrypted: string) {
    sessionStorage.setItem('auth', userIdEncrypted);
  }

  isAuthenticated(): boolean {
    return this.AccessToken == null ? false : true;
  }

  getIntroText(pageName: string, fundIds: string[] | null = null) {
    this.loadPageWiseConfigurationFromStorageIfNotAvailable();
    const indexOfPage = this.pageWiseIntroText.findIndex((d) => d.PageName == pageName.toUpperCase());
    if (indexOfPage >= 0) {
      const intoText = this.pageWiseIntroText[indexOfPage].IntroText;
      const regex = /\[IF FUND=([\d\w,]+)](.+?)\[ENDIF]/gi;
      let processedText = intoText;
      let match: RegExpExecArray | null;

      // Loop to find all matches in the input string
      while ((match = regex.exec(processedText)) !== null) {
          const conditionalFunds = match[1].split(','); // First capture group: FUND values
          const text = match[2]; // Second capture group: content between the tags

          // Determine if any fund matches
          const replacement = fundIds && conditionalFunds.some(f => fundIds.includes(f)) ? text : "";

          // Replace the match in tempInput with the replacement
          processedText = processedText.replace(match[0], replacement);

          regex.lastIndex = 0;
      }

      return processedText;
    }
    return '';
  }

  getGridConfig(pageName: string) {
    this.loadPageWiseConfigurationFromStorageIfNotAvailable();
    const indexOfPage = this.pageWiseIntroText.findIndex((d) => d.PageName == pageName.toUpperCase());
    if (indexOfPage >= 0) {
      return this.pageWiseIntroText[indexOfPage].GridColumnConfigs;
    }
    return [];
  }

  getRedirectUrl(): string {
    return this.redirectUrl;
  }

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  navigateToLogin() {
    this.router.navigate(['/']);
  }

  logout() {
    this.UserType = null;
    this.WpUserNum = null;
    this.RecordNum = null;
    this.AccessToken = null;
    this.gridColumnConfigs = null;
    this.navigateToLogin();
  }

  navigateToUrl(url, queryParam = null) {
    this.router.navigate([url], {queryParams: queryParam});
  }

  validateEmail(email): boolean {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  loadPageWiseConfigurationFromStorageIfNotAvailable() {
    if (!this.pageWiseIntroText || this.pageWiseIntroText.length < 1) {
      this.pageWiseIntroText = JSON.parse(localStorage.getItem('pageWiseIntroText'));
    }
  }

  getMenuListBasedOnUserType(): PageWiseIntroText[] {
    this.loadPageWiseConfigurationFromStorageIfNotAvailable();
    if (this.pageWiseIntroText && this.pageWiseIntroText.length > 0) {
      return this.pageWiseIntroText.filter((d) => d.IsVisibleInMenu == true && this.isThePageAuthorized(d.PageName));
    }
    return [];
  }

  isThePageAuthorized(pageNum: EnPageNameEnum) {
    this.loadPageWiseConfigurationFromStorageIfNotAvailable();
    const filterIndexOfSelectedPage = this.pageWiseIntroText.findIndex((d) => d.PageName == pageNum);
    // If the page doesn't exists in menu list, allow the access
    if (filterIndexOfSelectedPage < 0) {
      return true;
    } else if ((this.pageWiseIntroText[filterIndexOfSelectedPage].PageName == EnPageNameEnum.Reports ||
      this.pageWiseIntroText[filterIndexOfSelectedPage].PageName == EnPageNameEnum.RepStatements) && 
      this.ForBrokerNum && this.RecordNum != this.ForBrokerNum ) {
      return false;
    } else if (this.pageWiseIntroText[filterIndexOfSelectedPage].UserTypesAllowed[0] == '*' ||
      this.pageWiseIntroText[filterIndexOfSelectedPage].UserTypesAllowed.indexOf(this.UserType) >= 0) {
      return true;
    }
    return false;
  }

  // Utility Function
  numberWithCommas(x) {
    if (x === 0) {
      return x.toString();
    }
    if (x == null || typeof x === 'undefined') {
      return '0';
    }
    x = x.toString();
    const wholeNumber = x.split('.')[0];
    const decimalNumber = x.split('.').length > 1 ? ('.' + x.split('.')[1]) : '';
    return wholeNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + decimalNumber;
  }

  getFixedDecimalDigits(x, noOfDigits) {
    if (noOfDigits === -1) {
      if (x) {
        return x.toString().split('.')[0];
      }
      return x;
    }
    const number = x.toString();
    const wholeNumber = number.split('.')[0];
    let noToReturn = wholeNumber;
    noToReturn += '.';
    if (number.split('.').length > 1) {
      noToReturn = x.toFixed(noOfDigits);
    } else {
      for (let i = 0; i < noOfDigits; i++) {
        noToReturn += '0';
      }
    }
    return (noToReturn);
  }

  getQueryStringParam(url: string, keyText: string): string {
    const substringKey = url.split(keyText)[1];
    const indexOfNextParam = substringKey.indexOf('&');
    let keyValue;
    if (indexOfNextParam > 0) {
      keyValue = substringKey.substring(1, indexOfNextParam);
    } else {
      keyValue = substringKey.substring(1);
    }
    return keyValue;
  }

  navigateUrlInNewTab(url: string, objectToExtractInfoFrom: any) {
    url = url.replace('/Forms/', '');
    url = url.replace('.aspx', '');
    let pathUrl = location.protocol + '//' + location.hostname;
    if (location.port) {
      pathUrl += ':' + location.port;
    }

    pathUrl += '/#/' + url;
    if (url.indexOf('?') > 0) {
      pathUrl += '&ApplicationParallelWorkflow=true';
    } else {
      pathUrl += '?ApplicationParallelWorkflow=true';
    }
    pathUrl += '&WindowId=' + new Date().getTime();
    if (objectToExtractInfoFrom && objectToExtractInfoFrom.RecordNum) {
      pathUrl += '&RecordNum=' + objectToExtractInfoFrom.RecordNum;
    }
    if (objectToExtractInfoFrom && objectToExtractInfoFrom.RecordType) {
      pathUrl += '&UserType=' + objectToExtractInfoFrom.RecordType;
    }
    if (objectToExtractInfoFrom && objectToExtractInfoFrom.WpUserNum) {
      pathUrl += '&WpUserNum=' + objectToExtractInfoFrom.WpUserNum;
    }
    window.open(pathUrl);
  }

  /******************************Component+URL related Methods***************************/

  getFormNameFromUrl(hostedFormUrl) {

    if (hostedFormUrl) {
      /// Forms/Investor/InvestorAddressList.aspx
      hostedFormUrl = hostedFormUrl.replace('/Forms/', '');
      hostedFormUrl = hostedFormUrl.replace('.aspx', '');
    }
    return hostedFormUrl.split('?')[0];
  }

  getComponentTypeFromUrl(hostedFormUrl) {
    let found = false;
    let componentType: Type<any>;
    if (hostedFormUrl) {
      /// Forms/Investor/InvestorAddressList.aspx
      hostedFormUrl = hostedFormUrl.replace('/Forms/', '');
      hostedFormUrl = hostedFormUrl.replace('.aspx', '');
    }
    this.router.config.forEach((route) => {
      if (found) {
        return;
      }
      if (route.component && route.path == hostedFormUrl) {
        componentType = route.component;
        this.dataOfRecentlyFetchedComponentFromUrl = route.data;
        found = true;
      } else if (route.children) {
        route.children.forEach((child) => {
          if (child.component && (route.path + '/' + child.path) == hostedFormUrl) {
            componentType = child.component;
            this.dataOfRecentlyFetchedComponentFromUrl = child.data;
            found = true;
          }
        });
      }
    });
    if (found) {
      return componentType;
    }
    return null;
  }

  // ********************************************** */

  getTextAndVisiblityConfiguration(userType: string) {
    const configVisiblityAndTextObj: any = {};
    configVisiblityAndTextObj.myUserInfo = {};
    configVisiblityAndTextObj.myAccountInfo = {};
    configVisiblityAndTextObj.editProfile = {};

    switch (userType) {
      case EnUserTypes.Investor:
        configVisiblityAndTextObj.myUserInfo.headerText = 'Investor ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'Investor Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = true;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = true;
        configVisiblityAndTextObj.associateAccountDisp = true;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = true;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = false;

        if (this.PreviousLoggedInUser?.UserType == "D" && this.PreviousLoggedInUser?.UserClass == "1") {
          configVisiblityAndTextObj.associateAccountDisp = false;
          configVisiblityAndTextObj.changePasswordDisp = false;
          configVisiblityAndTextObj.editProfile.emailAddressDisable = true;
          configVisiblityAndTextObj.requestAddressChangeDisp = false;
        }

        break;
      case EnUserTypes.Rep:
        configVisiblityAndTextObj.myUserInfo.headerText = 'Advisor ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'Advisor Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = true;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = false;

        break;
      case EnUserTypes.Broker:
        configVisiblityAndTextObj.myUserInfo.headerText = 'Broker ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'Broker Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = true;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        break;
      case EnUserTypes.Custodian:
        configVisiblityAndTextObj.myUserInfo.headerText = 'Custodian ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'Custodian Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = true;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = false;

        break;
      case EnUserTypes.User:
        configVisiblityAndTextObj.myUserInfo.headerText = 'User ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'User Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = false;
        configVisiblityAndTextObj.changePasswordDisp = false;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = true;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = true;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = true;
        break;
      case EnUserTypes.DupMail:
        configVisiblityAndTextObj.myUserInfo.headerText = 'User ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'User Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = true;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = false;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = false;

        break;
      case EnUserTypes.Territory:
        configVisiblityAndTextObj.myUserInfo.headerText = 'Territory ID #';
        configVisiblityAndTextObj.myAccountInfo.headerText = 'Territory Account #';
        configVisiblityAndTextObj.myAccountInfo.addValidityDisp = false;
        configVisiblityAndTextObj.myAccountInfo.currentAddressDisp = false;
        configVisiblityAndTextObj.myAccountInfo.legalAddressDisp = false;
        configVisiblityAndTextObj.associateAccountDisp = false;
        configVisiblityAndTextObj.changePasswordDisp = true;
        configVisiblityAndTextObj.requestAddressChangeDisp = false;

        configVisiblityAndTextObj.editProfile.emailAddressDisable = false;
        configVisiblityAndTextObj.editProfile.passwordFieldDisable = false;
        configVisiblityAndTextObj.editProfile.changeActivationStatus = false;

        break;
    }
    return configVisiblityAndTextObj;
  }

  validateSecurityQuestionAnswer(securityQuestionAnswer: SecurityQuestionAnswer) {
    const validatedObj: any = {};
    let isValid = true;
    let alertMessage = '';

    if (!securityQuestionAnswer.SecQuestionCode1) {
      alertMessage = 'Please select security question 1';
      isValid = false;
    } else if (!securityQuestionAnswer.SecQuestionCode2) {
      alertMessage = 'Please select security question 2';
      isValid = false;
    } else if (!securityQuestionAnswer.SecQuestionCode3) {
      alertMessage = 'Please select security question 3';
      isValid = false;
    } else if (securityQuestionAnswer.SecQuestionCode1 === securityQuestionAnswer.SecQuestionCode2 || securityQuestionAnswer.SecQuestionCode1 == securityQuestionAnswer.SecQuestionCode3 ||
      securityQuestionAnswer.SecQuestionCode3 === securityQuestionAnswer.SecQuestionCode2) {
      alertMessage = 'All different question should be selected';
      isValid = false;
    } else if (!securityQuestionAnswer.SecAnswerText1 || !securityQuestionAnswer.SecAnswerText2 || !securityQuestionAnswer.SecAnswerText3) {
      alertMessage = 'All questions must be answered';
      isValid = false;
    }
    validatedObj.isValid = isValid;
    validatedObj.alertmessage = alertMessage;
    return validatedObj;
  }

  // ****************Methods to Handle opening Investor or other profile pages from client search*********//
  openApplicationWithDifferentUserType(dataItem, userType: string, userNum: string, filters: string[]) {
    const obj = {
      UserType: this.UserType,
      UserName: this.UserName,
      UserClass: this.UserClass,
      RecordNum: this.RecordNum,
      WpUserNum: this.WpUserNum,
      Filters: filters
    };
    this.UserType = userType;
    this.UserName = dataItem.RecordName;
    this.UserClass = dataItem.UserClass;
    this.RecordNum = dataItem.RecordNum;
    this.WpUserNum = userNum;

    this.storedFilters = [];

    this.TempUsers = [...(this.TempUsers || []), obj];

    setTimeout(() => {
      this.accessTokenRemovedSubj.next(false);
    });
    this.navigateToUrl('home');
  }

  backToPreviousInUse() {
    // Restore usertype,usename,recordnum
    const obj = this.popTempUser();
    this.UserType = obj.UserType;
    this.UserName = obj.UserName;
    this.RecordNum = obj.RecordNum;
    this.WpUserNum = obj.WpUserNum;
    this.storedFilters = obj.Filters;

    this.accessTokenRemovedSubj.next(false);
    this.navigateToUrl('clientsearch');
  }

  private popTempUser(): any {
    const prevUser = this.PreviousLoggedInUser;
    const arr = this.TempUsers;
    arr.pop();
    this.TempUsers = arr;
    return prevUser;
  }

  set2faRememberToken(login: string, token: string) {
    const key = `$2faRemember_${login}`;
    localStorage.setItem(environment.star_clientid+key, token);
  }

  get2faRememberToken(login: string): string {
    const key = `$2faRemember_${login}`;
    return localStorage.getItem(environment.star_clientid+key);
  }


  // ***********************************************Ends***************************************************//
}
